var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 2.94444C10.1204 2.94444 11.8394 4.68556 11.8394 6.83333V8.57524C11.8394 8.9562 11.9774 9.32393 12.2273 9.60868L13.2068 10.7249C13.8671 11.4773 13.3398 12.6667 12.3459 12.6667H3.65406C2.66023 12.6667 2.13292 11.4773 2.79318 10.7249L3.77273 9.60868C4.02261 9.32393 4.16065 8.9562 4.16065 8.57524L4.16066 6.83333C4.16066 4.68556 5.8796 2.94444 8.00002 2.94444ZM8.00002 2.94444V1M7.23207 15H8.76781",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.30b6b4f28a61dcfa6326fca47c1d1917.svg";
export { ForwardRef as ReactComponent };